import React, { useRef } from 'react';
import { SettingsSort18 } from 'shared/assets/icons';
import { Colors, IconButton } from 'shared/components/ui/icon-button';
import { useOpenMenu } from 'shared/hooks/use-open-menu';
import { FilterDocument } from 'shared/types/filter-document';

import { CompletedContextMenu } from './completed-context-menu';
import * as Styled from './page-top-bar.style';

export type InteractionsProps = {
  filterDocument: FilterDocument;
  setFilterDocument: React.Dispatch<React.SetStateAction<FilterDocument>>;
};

export const Interactions: React.FC<InteractionsProps> = ({
  filterDocument,
  setFilterDocument,
}) => {
  const { menuOpen, openMenu, closeMenu } = useOpenMenu();
  const buttonRef = useRef<HTMLButtonElement>(null);

  return (
    <Styled.Interactions>
      <IconButton
        ref={buttonRef}
        icon={SettingsSort18}
        onClick={openMenu}
        color={Colors.Default}
        highlighted={menuOpen}
        preventDrag
      />
      {menuOpen && (
        <CompletedContextMenu
          onClose={closeMenu}
          referenceElement={buttonRef}
          filterDocument={filterDocument}
          setFilterDocument={setFilterDocument}
        />
      )}
    </Styled.Interactions>
  );
};
